import {vec3} from 'gl-matrix';
import {Sounds} from './utils/soundfx-player.js';
import {Component, property, Property} from '@wonderlandengine/api';
import {storageSpace13} from './globals.js';
import {BoxState} from './classes/boxState.js';
import {Tags} from './tags.js';

export class BoxController extends Component {
    static TypeName = 'box-controller';

    @property.int(1)
    floorGroup = 1;

    boxState: BoxState;
    isMoving: boolean;
    time: number;
    startPosition = vec3.create();
    targetPosition = vec3.create();
    direction: any;

    /**
     * The new box state that is used by this component.
     * @param {BoxState} newBoxState the new box state
     */
    setState(newBoxState) {
        this.boxState = newBoxState;
        this.boxState.position = this.object.getPositionWorld([]);
    }

    update(dt) {
        if (!this.boxState) return;

        if (this.isMoving) {
            this.time += dt * 6;
            if (this.time > 1) {
                this.time = 1;
                let wall = this.checkWall(this.direction);
                if (!wall) {
                    this.startPosition = [this.targetPosition[0], this.targetPosition[1], this.targetPosition[2]];
                    vec3.add(this.targetPosition, this.targetPosition, this.direction);
                    this.time = 0;
                } else {
                    this.isMoving = false;
                    this.object.setPositionWorld(this.targetPosition);
                    this.boxState.position = Array.from(this.targetPosition);
                    storageSpace13.soundFxPlayer.playSound(Sounds.boxstop);
                    this.checkTarget(false);
                    return;
                }
            }
            let position = vec3.create();
            vec3.lerp(position, this.startPosition, this.targetPosition, this.time);
            this.object.setPositionWorld(position);
        }
    }

    slide() {
        this.checkTarget(true);
        let playerP = storageSpace13.gameState.playerPosition;
        let boxP = this.object.getPositionWorld(vec3.create());

        if (vec3.distance(boxP, playerP) < 1.1) {
            let dir = vec3.sub(vec3.create(), playerP, boxP);
            vec3.normalize(dir, dir);
            let dotForward = vec3.dot(dir, [0, 0, -1]);
            let dotRight = vec3.dot(dir, [1, 0, 0]);
            if (Math.abs(dotForward) > Math.abs(dotRight)) {
                if (dotForward > 0) {
                    this.direction = [0, 0, 1];
                } else {
                    this.direction = [0, 0, -1];
                }
            } else {
                if (dotRight > 0) {
                    this.direction = [-1, 0, 0];
                } else {
                    this.direction = [1, 0, 0];
                }
            }
            let wall = this.checkWall(this.direction);
            if (!wall) {
                storageSpace13.soundFxPlayer.playSound(Sounds.movebox);
                this.targetPosition = vec3.create();
                this.startPosition = boxP;
                this.isMoving = true;
                this.time = 0;
                vec3.add(this.targetPosition, boxP, this.direction);
            }
        }
    }

    checkTarget(beforeMoving) {
        let pos = this.object.getPositionWorld([]);
        let ray = this.engine.scene.rayCast([pos[0], pos[1] + 0.5, pos[2]], [0, -1, 0], 1 << this.floorGroup);
        if (ray.hitCount > 0) {
            let tags = ray.objects[0].getComponent(Tags);
            if (tags.hasTag('target')) {
                if (beforeMoving) {
                    storageSpace13.gameState.offTarget();
                } else {
                    storageSpace13.gameState.onTarget();
                }
            }
        }
    }

    checkWall(direction) {
        let pos = this.object.getPositionWorld([]);

        let ray = this.engine.scene.rayCast([pos[0], pos[1] + 0.5, pos[2]], direction, 1 << this.floorGroup);

        if (ray.hitCount > 0 && ray.distances[0] < 1) {
            let tags = ray.objects[0].getComponent(Tags);
            return tags && (tags.hasTag('wall') || tags.hasTag('box'));
        }
    }
}
